/**
 * IDs are minted on the device, not the server (doc/12 §The rules).
 *
 * A mould created in a basement store with no signal needs a stable identity
 * *before* the server ever hears about it - otherwise nothing can reference it
 * until sync lands, and the user is staring at a row that cannot be edited.
 *
 * `crypto.randomUUID` needs a secure context; dev runs over HTTPS and production
 * is HTTPS-only, but a plain-HTTP LAN test would otherwise hard-crash on create,
 * so there is a fallback.
 */
export function newId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  const bytes = new Uint8Array(16);
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < 16; i += 1) bytes[i] = Math.floor(Math.random() * 256);
  }
  // RFC 4122 v4 bits.
  bytes[6] = ((bytes[6] ?? 0) & 0x0f) | 0x40;
  bytes[8] = ((bytes[8] ?? 0) & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
